var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.editorHealthChecker.result),function(result){return _c('tr',{class:{ 'text-danger': result.result === 300 }},[_c('td',[_vm._v(_vm._s(result.rule))]),_vm._v(" "),_c('td',{staticClass:"text-center",class:{
								'text-success': result.result === 0,
								'text-warning': result.result === 100,
								'text-danger': result.result === 200 || result.result === 300,
							}},[_c('i',{staticClass:"fas bg-danger",class:{
								'fa-check-circle text-success': result.result === 0,
								'fa-info-circle text-warning': result.result === 100,
								'fa-exclamation-circle text-danger': result.result === 200,
								'fa-times-circle text-danger': result.result === 300,
							},attrs:{"title":result.message}})])])}),0)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"card-header language-list"},[_c('h3',{staticClass:"card-title"},[_vm._v("Article Health")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Rule")]),_vm._v(" "),_c('th')])])
}]

export { render, staticRenderFns }